import { updatesData } from '@/mocks/home';

const typeStyles: Record<string, string> = {
  update: 'bg-primary-50 text-primary-700',
  new: 'bg-accent-50 text-accent-800',
  upgrade: 'bg-secondary-100 text-secondary-800',
  notice: 'bg-background-200 text-foreground-600',
  feature: 'bg-accent-50 text-accent-700',
};

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-4xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block text-xs font-semibold text-primary-600 bg-primary-50 px-3 py-1 rounded-full mb-3">
            更新动态
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            天美影视最新动态
          </h2>
          <p className="text-sm text-foreground-500">
            剧集更新、新剧入库、系统升级一网打尽
          </p>
        </div>

        <div className="relative">
          <div className="absolute left-[19px] top-2 bottom-2 w-px bg-background-200 md:left-[23px]"></div>

          <div className="flex flex-col gap-1">
            {updatesData.map((item) => (
              <div key={item.id} className="relative flex items-start gap-4 md:gap-5 pl-12 md:pl-14 py-3">
                <div className="absolute left-[11px] top-[14px] w-[17px] h-[17px] rounded-full border-2 border-primary-400 bg-background-50 md:left-[14px] md:w-[19px] md:h-[19px] md:top-[16px]"></div>

                <div className="flex-1 min-w-0">
                  <div className="flex flex-wrap items-center gap-2 mb-1">
                    <span className={`text-xs font-medium px-2 py-0.5 rounded whitespace-nowrap ${typeStyles[item.type] || 'bg-background-200 text-foreground-600'}`}>
                      {item.tag}
                    </span>
                    <span className="text-xs text-foreground-400 whitespace-nowrap">
                      {item.date} {item.time}
                    </span>
                  </div>
                  <p className="text-sm text-foreground-700 font-medium">
                    {item.title}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}